import React from 'react'
import { Box, Link as MUILink } from '@mui/material'
import { Link } from 'react-router-dom'

interface LinksProps {
  text: string
  urls: string[]
  multiple: boolean
}

export function Links({ multiple, text, urls }: LinksProps) {
  if (!text || urls.length === 0) return null

  if (!multiple) {
    return (
      <Box component='p' mt={1}>
        <MUILink component={Link} to={urls[0]}>
          {text}
        </MUILink>
      </Box>
    )
  }

  return (
    <Box component='p' mt={1}>
      {urls.map((url, index) => (
        <React.Fragment key={index}>
          {index > 0 && <>,&nbsp;</>}
          <MUILink component={Link} to={url}>{`${text} (${index + 1})`}</MUILink>
        </React.Fragment>
      ))}
    </Box>
  )
}
